import React from 'react';
import { Carousel } from 'react-bootstrap';
import { useHistory } from "react-router-dom";

import bgImage1 from '../img/explainer/au-nuget.png';
import bgImage2 from '../img/explainer/au-varna.png';
import bgImage3 from '../img/explainer/au-plating.png';
import bgImage4 from '../img/explainer/au-coin.png';
import bgImage5 from '../img/explainer/au-glass.png';
import bgImage6 from '../img/explainer/au-bar.png';
import bgImage7 from '../img/explainer/au-chip.png';


const CarouselContainerAurum = () => {

  let history = useHistory();

  const  Next= () => {
      setTimeout(() => { history.push("/midgame"); }, 600);
  };

    return (
        <Carousel>

  <Carousel.Item interval={30000}> 
    <img
      className="d-block w-100"
      src={bgImage1}
      alt="First slide"
    />
    <Carousel.Caption>
      <h3>Zlato v prírode</h3>
      <p>Podľa niektorých zdrojov je možné uvažovať s tým, že človek zlato vyhľadával a používal najmenej 40 000 rokov pnl. a viac.
    </p>    
    </Carousel.Caption>
  </Carousel.Item>

  <Carousel.Item interval={30000}> 
    <img
      className="d-block w-100"
      src={bgImage2}
      alt="Second slide"
    />
    <Carousel.Caption>
      <h3>Poklad z Varny</h3>
      <p>Zlatý poklad z bulharskej Varny sa datuje do obdobia doby bronzovej cca 4400 až 4100 rokov pnl.
    </p>    
    </Carousel.Caption>
  </Carousel.Item>

  <Carousel.Item interval={30000}>
    <img
      className="d-block w-100"
      src={bgImage3}
      alt="Third slide"
    />
    <Carousel.Caption>
      <h3>Pozlacovanie</h3>
      <p>Pozlacovanie je spomínané už u Herodota v Starom zákone a vyobrazené je už v egyptských reliéfoch z obdobia 2955 až 2500 rokov pnl.
</p>
    </Carousel.Caption>
  </Carousel.Item>

  <Carousel.Item interval={30000}>
    <img
      className="d-block w-100"
      src={bgImage4}
      alt="Third slide"
    />
    <Carousel.Caption>
      <h3>Prvé peniaze</h3>
      <p>Prvé peniaze pochádzajú z území Lýdie a Číny z obdobia cca 564 Bc.
</p>
    </Carousel.Caption>
  </Carousel.Item>

  <Carousel.Item interval={30000}>
    <img
      className="d-block w-100"
      src={bgImage5}
      alt="Third slide"
    />
    <Carousel.Caption>
      <h3>Rubínové sklo</h3>
      <p>Purpurový pigment na farbenie skla, ktorý vzniká reakciou soli zlata s chloridem cínatým bol prvý krát pripravený v roku 1673 v Hamburgu 
</p>
    </Carousel.Caption>
  </Carousel.Item>

  <Carousel.Item interval={30000}>
    <img
      className="d-block w-100"
      src={bgImage6}
      alt="Third slide"
    />
    <Carousel.Caption>
      <h3>Zlatý štandard</h3>
      <p>Krytie hodnoty peňazí zlatom tzv. klasický zlatý štandard bol zavedený v období  1871–1914. Opustený bol definitívne v 70. rokoch 20. storočia.
</p>
    </Carousel.Caption>
  </Carousel.Item>

  <Carousel.Item interval={30000}>
    <img
      className="d-block w-100"
      src={bgImage7}
      alt="Third slide"
    />
    <Carousel.Caption>
      <h3>Zlato v elektrotechnike</h3>
      <p>Zlato dostalo význam v tejto oblasti s masívnym nástupom polovodičov a miniaturizáciou na konci 20. storočia.
</p>
    <div className='next-btn-container'>
      <button className='next-btn' onClick={() => Next()} >Další level</button>
    </div>
    

    </Carousel.Caption>
  </Carousel.Item>



</Carousel>

    )
}

export default CarouselContainerAurum;